import {lazy, Suspense} from 'react'

import {LazyImportVideoCard, Loading} from '@sdox/ui'

import {useBlockSiblings} from '../../hooks/useBlockSiblings'
import {BlockError} from './BlockError'

import type {XcNwBlock_BlockVideoWithDescriptionType_Fragment} from '@sdox/api'

const VideoCard = lazy(() => LazyImportVideoCard)

export const BlockVideoWithDescriptionType = (props: XcNwBlock_BlockVideoWithDescriptionType_Fragment) => {
  const {
    url,
    optionalTitle,
    videoDescription,
    thumbnail,
    openInNewTab,
    disclaimer,
    pullout,
    duration,
  } = props
  const {next} = useBlockSiblings(props)

  if (!url) return <BlockError />

  return (
  // The aspect-ratio for Loading indicator is not exact since the Loading indicator is subject to change.
  // It is close to the correct ratio to avoid big UI jumps.
    <Suspense fallback={<Loading className={'aspect-[3/1]'} />}>
      <VideoCard
        optionalTitle={optionalTitle}
        videoDescription={videoDescription}
        url={url}
        showBottomBorder={next?.__typename === 'BlockExternalLinkType' || next?.__typename === 'BlockVideoWithDescriptionType'}
        thumbnail={thumbnail?.thumbnailUrl} // TODO choose the right thumbnail
        openInNewTab={openInNewTab}
        disclaimer={disclaimer}
        pullout={pullout}
        duration={duration}
      />
    </Suspense>
  )
}
